(function () {
  'use strict';

  var pageLoadedAt = Date.now();
  var MIN_SUBMIT_DELAY = 3000;
  var MAX_LINKS = 0;
  var LINK_REGEX = /(https?:\/\/|www\.)[^\s<>"']*/gi;

  function blockSilently(event) {
    event.preventDefault();
    event.stopImmediatePropagation();
  }

  function countLinks(text) {
    var count = 0;
    LINK_REGEX.lastIndex = 0;
    while (count <= MAX_LINKS && LINK_REGEX.exec(text) !== null) {
      count += 1;
    }
    return count;
  }

  function showLinkError(form, messageInput) {
    var alert = form.querySelector('#velio-anti-spam-alert');
    if (!alert) {
      alert = document.createElement('p');
      alert.id = 'velio-anti-spam-alert';
      alert.setAttribute('role', 'alert');
      alert.style.cssText = 'color:inherit;font-size:inherit;margin-top:0.5rem;';
      (messageInput.parentNode || form).appendChild(alert);
    }
    alert.textContent = 'Merci de retirer les liens de votre message.';
    messageInput.focus();
  }

  document.addEventListener('submit', function (event) {
    var form = event.target;
    if (!form || !form.querySelector) return;
    var honeypot = form.querySelector('input[name="velio_hp"]');
    if (!honeypot) return;

    if (honeypot.value !== '') {
      blockSilently(event);
      return;
    }

    if (Date.now() - pageLoadedAt < MIN_SUBMIT_DELAY) {
      blockSilently(event);
      return;
    }

    var formType = form.querySelector('input[name="form_type"]');
    if (formType && formType.value === 'contact') {
      var areas = form.querySelectorAll('textarea');
      var messageInput = null;
      for (var i = 0; i < areas.length; i++) {
        if (countLinks(areas[i].value) > MAX_LINKS) { messageInput = areas[i]; break; }
      }
      if (messageInput) {
        event.preventDefault();
        event.stopImmediatePropagation();
        showLinkError(form, messageInput);
      }
    }
  }, true);
})();
